import React, { useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";

const ImageInput = ({ fieldName, control, fieldLabel, error, onChangeValue }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event, field) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    field.onChange(file); // Updates react-hook-form field
    if (onChangeValue) onChangeValue(file);
  };

  return (
    <FormGroup>
      <Label htmlFor={fieldName} className="col-form-label">
        {fieldLabel}
      </Label>
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <div>
          <input
            type="file"
            id={fieldName}
            accept="image/*"
            onChange={(e) => handleFileChange(e, field)}
          />
          </div>
        )}
      />
      {error && (
        <p
          role="alert"
          style={{
            color: "red",
            paddingLeft: "10px",
            fontSize: "12px",
          }}
        >
          {error.message}
        </p>
      )}
    </FormGroup>
  );
};

export default ImageInput;
